import React, { useEffect } from 'react';
// Material helpers
import { ThemeProvider } from '@mui/material';
import theme from './theme';
import './assets/scss/index.scss';

// Language
import Spanish from './lang/sp.json';
import English from './lang/en.json';
import { useSelector } from 'react-redux';
import { IntlProvider } from 'react-intl';

// Routes
import AppRoutes from './Routes';

// Moment.js
import moment from 'moment';
import 'moment/locale/es'; // Importa español
import 'moment/locale/en-gb'; // Importa inglés británico (más formal)

function App() {
  const prefLang = useSelector((state) => state.prefs.prefLang);
  const prefLocale = useSelector((state) => state.prefs.locale);

  // Map language to messages and locale
  const messages = prefLang === 'es' ? Spanish : English;
  const locale = prefLocale || (prefLang === 'es' ? 'es-MX' : 'en');

  // Configurar Moment.js con el idioma dinámico
  useEffect(() => {
    moment.locale(prefLang === 'es' ? 'es' : 'en'); // Cambia el idioma globalmente
  }, [prefLang]);

  return (
    <IntlProvider locale={locale} messages={messages}>
      <ThemeProvider theme={theme}>
        <AppRoutes />
      </ThemeProvider>
    </IntlProvider>
  );
}

export default App;
